<template>
  <div class="member-stats">
    Your Stats
    <ul class="stats-list">
      <li v-if="showCompleteCount">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined -complete">check_circle</i>
        </span>
        <span class="detail-value" aria-label="Completes">{{
          loggedInStat(numberFormat(completeCount))
        }}</span>
      </li>
      <li v-if="showFavorite && isEntityFavorited">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined fill -content-match">favorite</i>
        </span>
        <span class="detail-value" aria-label="Favorites">Favorited</span>
      </li>
      <li v-if="showInProgress && isPlanInProgress">
        <span class="detail-icon" aria-hidden="true">
          <i class="material-symbols-outlined -in-progress">loop</i>
        </span>
        <span class="detail-value" aria-label="In Progress">In Progress</span>
      </li>
      <li v-if="showUpcoming && isPlanUpcoming">
        <span class="detail-icon" aria-hidden="true">
          <!--  This icon has a bug. 'event_upcoming' shows both event and upcoming icons next to each other.-->
          <i class="material-symbols-outlined -upcoming">event</i>
        </span>
        <span class="detail-value" aria-label="Upcoming">Upcoming</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'
import { useFavoritesStore } from '@/stores/favorites'
import { useCalendarStore } from '@/stores/calendar'
import { useCompletesStore } from '@/stores/completes'
import { numberFormat } from '@/utils/helpers'

export default defineComponent({
  name: 'StatsMember',
  components: {},
  props: {
    showCompleteCount: {
      type: Boolean,
      default: true,
    },
    // favorites powered by pinia, but still allow to turn off
    showFavorite: {
      type: Boolean,
      default: true,
    },
    // plan in progress powered by pinia
    showInProgress: {
      type: Boolean,
      default: false,
    },
    // future scheduled
    showUpcoming: {
      type: Boolean,
      default: false,
    },

    // needed if showing favorites
    entityId: {
      required: true,
      type: Number,
    },
    entityType: {
      default: 'workout',
      type: String,
      validator: (val: string) =>
        ['workout', 'article', 'wellness_video', 'custom_workout', 'plan'].includes(val),
    },
    entityCategory: {
      default: '',
      validator: (val: string) => ['', 'program', 'challenge', 'routine'].includes(val),
    },
  },
  data() {
    return {}
  },

  computed: {
    ...mapState(useUserAuthStore, ['user']),
    ...mapState(useCalendarStore, ['scheduledPlansStats']),
    ...mapState(useCompletesStore, ['userCompletes']),
    ...mapState(useFavoritesStore, ['isFavorite']),
    ...mapState(useUserAuthStore, ['isFbAdminUser']),
    ...mapState(useCalendarStore, ['getScheduledPlanStats']),

    completeCount(): number {
      return this.userCompletes({
        schedulableType: this.entityType,
        schedulableId: this.entityId,
      })
    },

    // just a helper to pass in entity
    isEntityFavorited() {
      return this.isFavorite({
        favoritableType: this.entityType,
        favoritableId: this.entityId,
      })
    },

    isPlanInProgress() {
      return !!this.getScheduledPlanStats(this.entityId)?.inProgress
    },

    isPlanUpcoming() {
      return !!this.getScheduledPlanStats(this.entityId)?.upcomingCount
    },
  },
  methods: {
    // proxy method
    numberFormat(val: any) {
      return numberFormat(val)
    },

    loggedInStat(stat: string) {
      if (!this.user.isLoggedIn) {
        return 'N/A'
      }

      return stat
    },
  },
})
</script>
